export function wordDiff(from = "", to = "") {
  const a = from.split(/(\s+)/), b = to.split(/(\s+)/);
  if (a.length * b.length > 4_000_000) return [{ t: "del", v: from }, { t: "add", v: to }];
  const n = a.length, m = b.length;
  const dp = Array.from({ length: n + 1 }, () => new Uint32Array(m + 1));
  for (let i = n - 1; i >= 0; i--) for (let j = m - 1; j >= 0; j--) dp[i][j] = a[i] === b[j] ? dp[i + 1][j + 1] + 1 : Math.max(dp[i + 1][j], dp[i][j + 1]);
  const out = [];
  const push = (t, v) => (out.length && out[out.length - 1].t === t ? (out[out.length - 1].v += v) : out.push({ t, v }));
  let i = 0, j = 0;
  while (i < n && j < m) {
    if (a[i] === b[j]) { push("same", a[i]); i++; j++; } else if (dp[i + 1][j] >= dp[i][j + 1]) push("del", a[i++]); else push("add", b[j++]);
  }
  while (i < n) push("del", a[i++]);
  while (j < m) push("add", b[j++]);
  return out;
}
